import { Input, Modal, Typography, message } from "antd";
import { useState } from "react";

const { Text } = Typography;

export type UnlockUserTarget = {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
};

interface Props {
  user: UnlockUserTarget | null;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => Promise<void> | void;
}

export const ModalUnlockUser = ({
  user,
  loading = false,
  onCancel,
  onConfirm,
}: Props) => {
  const [reason, setReason] = useState("");
  const fullName = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .join(" ");

  const handleOk = async () => {
    const trimmed = reason.trim();
    if (!trimmed) {
      message.warning("Indica el motivo del desbloqueo");
      return;
    }
    await onConfirm(trimmed);
  };

  const handleCancel = () => {
    setReason("");
    onCancel();
  };

  return (
    <Modal
      title="Desbloquear usuario"
      open={!!user}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Desbloquear"
      cancelText="Cancelar"
      confirmLoading={loading}
      destroyOnClose
      afterClose={() => setReason("")}
    >
      <Text style={{ display: "block", marginBottom: 12 }}>
        Indica el motivo para desbloquear
        {fullName ? ` a ${fullName}` : ""}
        {user ? ` (ID ${user.id})` : ""}. Quedará registrado quién lo hizo.
      </Text>
      <Input.TextArea
        rows={4}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Motivo del desbloqueo"
        maxLength={500}
        showCount
      />
    </Modal>
  );
};
